import { getEnv } from '@products/runtime-env';

export function env(key: string): string {
  return getEnv(key);
}
